import React from 'react';
import classNames from 'classnames';
import {Grid, GridCol, spaceHelpers} from '@flixbus/honeycomb-react';
import LinesFilter from './LinesFilter/LinesFilter';
import CalculationNameFilter from './CalculationNameFilter/CalculationNameFilter';
import PartnersFilter from './PartnersFilter/PartnersFilter';
import PlanningPeriod from './PlanningPeriod/PlanningPeriod';
import CountriesFilter from './CountriesFilter/CountriesFilter';
import CalculationStatusFilter from './CalculationStatusFilter/CalculationStatusFilter';
import CalculationOriginFilter from './CalculationOriginFilter/CalculationOriginFilter';

const FiltersContainer: React.FC = () => {
  const {3: space3} = spaceHelpers();

  return (
    <div
      className={classNames(
        space3.top,
        space3.right,
        space3.bottom,
        space3.left
      )}
    >
      <Grid>
        <GridCol size={3}>
          <PartnersFilter />
        </GridCol>
        <GridCol size={3}>
          <LinesFilter />
        </GridCol>
        <GridCol size={3}>
          <PlanningPeriod />
        </GridCol>
        <GridCol size={3}>
          <CalculationStatusFilter />
        </GridCol>
      </Grid>
      <Grid>
        <GridCol size={3}>
          <CountriesFilter />
        </GridCol>
        <GridCol size={3}>
          <CalculationNameFilter />
        </GridCol>
        <GridCol size={3}>
          <CalculationOriginFilter />
        </GridCol>
      </Grid>
    </div>
  );
};

export default React.memo(FiltersContainer);
